<template>
    <div class="favorite-bar-container">
        <!--<img :src="imageUrl" />-->
        <div class="favorite-bar-image-wrapper">
            <div :key="'favimg-'+imageUrl" :style="imgStyle" class="favorite-bar-image"></div>
        </div>
        <div class="favorite-bar-content">
            <BreadCrumb v-if="isEditable" color="white"></BreadCrumb>
            <div style="display: flex;flex-direction: row; align-items: center; justify-content: flex-start">
                <span :title="status" :class="[_status.className]"
                      :style="{color: _status.color, fontSize: '12px'}"></span>
                <h2 style="margin: 0 8px; text-transform: uppercase">{{headline}}</h2>
            </div>
            <div style="margin-top: 15px; display: flex;flex-direction: row">
                <span class="icon icon-gallery" style="font-size: 32px;cursor: pointer; margin-right: 20px"
                      @click="scrollToAttachments"></span>
                <span class="icon icon-video" style="font-size: 32px;cursor: pointer" @click="scrollToAttachments"></span>
            </div>
        </div>
    </div>
</template>

<script>
    import BreadCrumb from "../../components/breadCrumb/BreadCrumb";

    export default {
        name: "DashboardFavoriteBar",
        components: {
            BreadCrumb
        },
        props: {
            medium: {
                required: true
            }
        },
        data: function () {
            return {
                imageUrl: ''
            }
        },
        computed: {
            headline() {
                let adSpecial = this.$store.state.campaign.campaign.ad_special ? this.$store.state.campaign.campaign.ad_special.name : '';
                return this.$store.state.campaign.campaign.customer + ' | ' +
                    this.$store.state.campaign.campaign.name + ' | ' + adSpecial;
            },
            status() {
                return this.$store.state.campaign.campaign.status;
            },
            _status: function () {
                let ret = {};
                if (this.status === "live") {
                    ret.className = 'icon-status-live';
                    ret.color = "rgb(215,4,101)";
                } else if (this.status === "ausgelaufen") {
                    ret.className = 'icon-status-finished';
                    ret.color = "rgb(36,39,45)";
                } else if (this.status === "in Arbeit") {
                    ret.className = 'icon-status-inprogress';
                    ret.color = "rgb(128,128,128)";
                } else if (this.status === "gecheckt") {
                    ret.className = 'icon-status-inprogress';
                    ret.color = "rgb(1,182,233)";
                } else if (this.status === "eingebaut") {
                    ret.className = 'icon-status-inprogress';
                    ret.color = "rgb(215,4,101)";
                }
                return ret;
            },
            imgStyle() {
                let bgImgVal = '';
                if (this.$browserDetect.isSafari) {
                    bgImgVal = '-webkit-linear-gradient(90deg, rgba(117, 43, 119, 0.9) 0%, rgba(0, 182, 237, 0.9) 100%),\n' +
                        '                url(' + this.imageUrl + ')';
                } else if (this.$browserDetect.isFirefox) {
                    bgImgVal = '-moz-linear-gradient(90deg, rgba(117, 43, 119, 0.9) 0%, rgba(0, 182, 237, 0.9) 100%),\n' +
                        '                url(' + this.imageUrl + ')';
                } else {
                    bgImgVal = 'linear-gradient(90deg, rgba(117, 43, 119, 0.9) 0%, rgba(0, 182, 237, 0.9) 100%),\n' +
                        '                url(' + this.imageUrl + ')';
                }
                return {
                    'background-image': bgImgVal
                };

            },
            isEditable() {
                if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                    return false;
                } else if (typeof this.$route.query.key !== 'undefined') {
                    return false;
                }
                return true;
            }
        },
        watch: {
            medium: {
                handler(val) {
                    for (let i = 0; i < val.attachments.length; i++) {
                        let attachment = val.attachments[i];
                        if (attachment.is_favorite === 1) {
                            this.imageUrl = attachment.url;
                        }
                    }
                },
                deep: true
            }
        },
        mounted() {
            for (let i = 0; i < this.medium.attachments.length; i++) {
                let attachment = this.medium.attachments[i];
                if (attachment.is_favorite === 1) {
                    this.imageUrl = attachment.url;
                }
            }
        },
        methods: {
            scrollToAttachments() {
                let container = document.getElementById('attachment-area');
                container.scrollIntoView();
            },
            openFavorite() {
                this.scrollToAttachments();
                this.$root.$emit('openFavorite');
            }
        }
    }
</script>

<style lang="scss" scoped>

    img {
        width: 100%;
        position: absolute;
        clip: rect(0, 100vw, 200px, 0);
        margin-top: -1em;
    }

    .favorite-bar-content {
        width: 100%;
        max-width: 1400px;
        margin: auto;
        position: relative;
        z-index: 10;
        color: white
    }

    .favorite-bar-container {
        height: 300px;
        overflow-y: hidden;
    }

    .favorite-bar-image {
        width: 100%;
        height: 100%;
        -webkit-filter: blur(3px); /* Safari 6.0 - 9.0 */
        filter: blur(3px);
        object-position: center;
        object-fit: cover;
        left: -15px;
        right: -15px;
        top: -15px;
        bottom: -15px;
        transform: scale(1.1);
        background: rgb(117, 43, 119) 0 10%;
    }

    .favorite-bar-image-wrapper {
        width: 100%;
        height: 300px;
        left: 0;
        position: absolute;
        overflow: hidden;
    }

    @media screen and (min-width: 1200px) {
        .favorite-bar-image-wrapper {
            top: 70px;
        }
    }

    @media (max-width: 768px) {
        .favorite-bar-content {
            padding-top: 2rem;
        }
    }

    ::v-deep #contentContainer {
        width: 100%;
        padding: 0;
    }

    @media (min-width: 768px) and (max-width: 1199px) {
        .favorite-bar-content {
            padding-top: 2rem;
            padding-left: 1rem;
            padding-right: 1rem;
        }
    }


</style>